export const PRICE_BASIS = {
  PER_YEAR: "per_year",
  WHOLE_TERM: "whole_term",
};

export const PRICE_BASIS_LABELS = {
  [PRICE_BASIS.PER_YEAR]: "Per year",
  [PRICE_BASIS.WHOLE_TERM]: "The whole term",
};

const AMOUNT_PATTERN = /^\d+(\.\d{1,2})?$/;

/** The message for an amount a price version can't hold, or null. */
export const priceAmountError = (draft, prices, ownIndex = -1) => {
  const amount = String(draft).trim();
  if (!AMOUNT_PATTERN.test(amount) || parseFloat(amount) <= 0) {
    return "Enter a price greater than $0 with at most 2 decimal places.";
  }
  const isDuplicate = prices.some(
    (price, index) =>
      index !== ownIndex && parseFloat(price.amount) === parseFloat(amount)
  );
  return isDuplicate ? "This price already exists on this product." : null;
};

export const formatPrice = amount =>
  `$${parseFloat(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

/** A product's prices that can be picked on an invoice line, current first. */
export const selectablePrices = product =>
  [...(product?.prices ?? [])]
    .filter(price => price.enabled)
    .sort((a, b) => Number(b.is_current) - Number(a.is_current));
